// Pagination
export const DEFAULT_PAGE = 1;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_ROWS = 0;
export const GET_ALL_RECORDS = -1;
export const PAGINATION_NUMBER = 2;
export const RECORDS_PER_PAGE = 4;
export const RECORDS_PER_SLIDER = 10;
export const AUTOCOMPLETE_LIMIT = 3;
export const STATISTIC_LIMIT = 10;

// Timeouts
export const RESPONSE_MESSAGE_VISIBILITY_MS = 3000;

// Screens
export const DESKTOP_1 = 1360;
export const DESKTOP_2 = 1024;
export const TABLET_1 = 650;
export const TABLET_2 = 800;

export const FILE_TYPES = ["jpeg", "jpg", "png", "bmp"];

export const MEGABYTE = 1000000;

export const MINUTES_IN_DAY = 1440;

export const MILLISECONDS_IN_MINUTE = 60000;

export const MIN_RATING = 1;
export const MAX_RATING = 5;
